export function getRunnableWorkflowId(
  routeWorkflowId: string | undefined,
  savedWorkflowId: string | undefined
): string | undefined {
  return routeWorkflowId ?? savedWorkflowId
}

export function shouldOpenWorkflowTestPanel(
  searchParams: URLSearchParams,
  routeWorkflowId: string | undefined,
  savedWorkflowId: string | undefined
): boolean {
  return (
    searchParams.get("test") === "true" &&
    Boolean(getRunnableWorkflowId(routeWorkflowId, savedWorkflowId))
  )
}
